import { AnalysisLiveReportPreviewProps } from '../types';
import LiveReportPreviewMFE from '../mfe';

export const POTopicsLiveReportPreview = (
  props: AnalysisLiveReportPreviewProps
) => {
  return <LiveReportPreviewMFE {...props} />;
};
